import { all, takeEvery, put, fork } from 'redux-saga/effects';

import axios, { initIdleTimeout } from './initialize'
import { Modal } from 'antd';
import {CheckCircleFilled} from  '@ant-design/icons';

import {  GET_APP_PARAMETERS_LIST,UPDATE_APP_PARAMETER,DELETE_APP_PAREMETER,ADD_APP_PARAMETER} from "redux/constants/appParameters";

import { appParametersList, showAppParametersMessage,registerSuccess } from "redux/actions/appParameters";
import { showUnAutherizeMessage} from "redux/actions/Auth";

import { API_BASE_URL, APP_PREFIX_PATH, MANAGE_PREPIX_PATH } from 'configs/AppConfig';
import {
	AUTH_TOKEN,
} from '../constants/Auth';
import {PATH_VARIABLE} from 'constants/ApiConstant';
import { t } from 'i18next';
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";

export function* getAppParametrsList(){
    yield takeEvery (GET_APP_PARAMETERS_LIST, function*  ({requestData}){
		const {query, sorter,pagination} = requestData;
      const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const queryParam = query ?? '';
		const sortField = sorter?.field ?? '';
		const sortOrder = sorter?.order ?? '';
		const page = (pagination?.current ?? 1) - 1;
		const size = pagination?.pageSize ?? 10;
		const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/parameter/appParameterList?query=${queryParam}&sortfield=${sortField}&sortorder=${sortOrder}&page=${page}&size=${size}`,
		config);
			if (res.status===200) {
				if(query!=undefined && query!=""){
					const traceObj ={
						type: `search_app_parameters_list`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `App Parameters List Retrieve Sucessfully`,
						action: `Search App Parameters List`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_app_parameters_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found`,
					status: `App Parameters List Retrieve  Sucessfully`,
					action: `Clicked get app parameters list `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(appParametersList(res.data));
			} 
		} catch (err) {
			if(query!=undefined && query!=""){
				const traceObj ={
					type: `search_app_parameters_list`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Retrieve App Parameters List`,
					action: `Search App Parameters List`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_app_parameters_list`,
				event: 'click',
				message: `0 results found`,
				status: `Failed To Retrieve App Parameters List`,
				action: `Clicked get app parameters list `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err.response.data.status==401){
				yield put(showAppParametersMessage(err.response));
			}
			yield put(showAppParametersMessage(err.response));
		}
    }

    )
}

export function* saveAppParameter() {
	yield takeEvery(ADD_APP_PARAMETER, function* ({ payload }) {
	  try {
		const accountId = localStorage.getItem("accountId");
		const {query, sorter,pagination} = payload;
		const config = {
		  headers: {
			"Content-Type": "application/json",
			"Access-Control-Allow-Origin": "*",
			"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			"accountId" : localStorage.getItem("accountId"),
			"appInstanceId":localStorage.getItem("appInstanceId"),
			accountUserId: localStorage.getItem("accountUserId")
		  },
		};
		const response = yield axios.post(
		  `${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/parameter/appParameter`,
		  payload,
		  config
		);
		if (response.status === 200) {
			if (payload?.parameterName === 'idleTime' && payload?.parameterValue != null) {
				localStorage.setItem('idleTime', String(payload.parameterValue));
				initIdleTimeout({ freshStart: true });
			}
			const traceObj ={
				type: `save_app_parameter`,
				event: 'click',
				message: `App Parameter Saved Sucessfuly`,
				status: `App Parameter Saved Sucessfuly`,
				action: `Clicked save app parameter`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
   		    Modal.success({
			title: t("impaqx.adminApp.appParameterCreateMessage"),
			icon: <CheckCircleFilled />,
			okText: t("impaqx.adminApp.close"),
			//cancelText: 'Cancel',
			onOk() {
			  //deleteApp(id);
			},
		  });
		  yield put(registerSuccess(response));
		}
		
	  } catch (err) {
		const traceObj ={
			type: `save_app_parameter`,
			event: 'click',
			message: `Failed To Save App Parameter`,
			status: `Failed To Save App Parameter`,
			action: `Clicked save app parameter`,
			referer_action_id: localStorage.getItem("referer_action_id"),
			trackId: uuidv4(),
			user_session: sessionStorage.getItem("user_session")
		  };
		  localStorage.setItem("referer_action_id",traceObj.trackId);
		  trace({"traceObj":traceObj});
		console.log(err);
		yield put(showAppParametersMessage(err.response));
	  }
	});
  }
export function* updateAppParameter(){
    yield takeEvery (UPDATE_APP_PARAMETER,function* ({payload}){
        try {
            const res = yield axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/parameter/appParameter/${payload.id}`, payload,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
             if (res.status===200) {
				if (payload?.parameterName === 'idleTime' && payload?.parameterValue != null) {
					localStorage.setItem('idleTime', String(payload.parameterValue));
					initIdleTimeout({ freshStart: true });
				}
				const traceObj ={
					type: `update_app_parameter`,
					event: 'click',
					message: `App Parameter Updated Sucessfuly For Id=${payload.id} `,
					status: `App Parameter Updated Sucessfuly`,
					action: `Clicked update app parameter`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				yield put(registerSuccess(res));
				Modal.success({
					title: t("impaqx.adminApp.appParameterUpdateMessage"),
					icon: <CheckCircleFilled />,
					okText: t("impaqx.adminApp.close"),
					//cancelText: 'Cancel',
					onOk() {
					  //deleteApp(id);
					},
				  });
				} 
        } catch (error) {
			const traceObj ={
				type: `update_app_parameter`,
				event: 'click',
				message: `Failed To Update App Parameter For Id=${payload.id} `,
				status: `Failed To Update App Parameter`,
				action: `Clicked update app parameter`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
            console.log(error);
			if(error.response.data.status==401){
				yield put(showAppParametersMessage(error.response));
			}
			yield put(showAppParametersMessage(error.response));
        }
    }
    )
}

export function* deleteAppParameters(){
	yield takeEvery(DELETE_APP_PAREMETER, function*({payload}){
         try {
			const {query, sorter,pagination} = payload;
			 const res = yield axios.delete(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/parameter/appParameter/${payload.id}`,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
			 if(res.status===200){
				const traceObj ={
					type: `delete_app_parameter`,
					event: 'click',
					message: `App Parameter Deleted Sucessfuly For Id=${payload.id} `,
					status: `App Parameter Deleted  Sucessfuly`,
					action: `Clicked delete app parameter`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				 //yield put(showAccountMessage(res));
				 const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/parameter/appParameterList?query=${query}&sortfield=${sorter?.field}
				 &sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
				 {headers: {
					'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
					'Access-Control-Allow-Origin' : '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					accountUserId: localStorage.getItem("accountUserId")
				  }});
					if (res.status===200) {
						Modal.success({
							title: `${payload.parameterName}  ${t("impaqx.adminApp.deleteParameterMessage")}`,
							icon: <CheckCircleFilled />,
							okText: 'Close',
							//cancelText: 'Cancel',
							onOk() {
								//deleteApp(id);
							},
						});
						yield put(appParametersList(res.data));
					} 
			 }
		 } catch (error) {
			const traceObj ={
				type: `delete_app_parameter`,
				event: 'click',
				message: `Failed To Delete App Parameter Id=${payload.id} `,
				status: `Failed To Delete App Parameter`,
				action: `Clicked delete app parameter`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			 console.log(error);
			 if(error.response.data.status==401){
				yield put(showAppParametersMessage(error.response));
			}
			 yield put(showAppParametersMessage(error.response));
		 }
	})
}



export default function* rootSaga(){
    yield all([
		  fork(getAppParametrsList),
		  fork(deleteAppParameters),
		  fork(saveAppParameter),
		  fork(updateAppParameter)
    ])
    
}